import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Signup from './Signup';
import { submit, dataSelector } from './duck/signup-reducer';

const mapStateToProps = state => ({
  data: dataSelector(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onSubmit: submit,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Signup);



// WEBPACK FOOTER //
// ./src/features/Signup/SignupContainer.js